import { isDevEnv } from 'src/utils/isDevEnv';
import { baseUrl } from './capabilities';

export class SSORedirect {
  static urlProviderSelection = `${window.config.oidcClientUrl}/provider/selection`;

  static get urlBase() {
    const url = new URL(SSORedirect.urlProviderSelection);

    if (window.config.sso?.provider_id) {
      url.searchParams.append('provider_id', window.config.sso?.provider_id);
    }

    return url.href;
  }

  static get agencyIdParam() {
    const agencyCreationEnabled =
      window.config.applicationMode.agent_portal?.agency_creation?.enabled;
    const params = new URLSearchParams(window.location.search);
    const agencyIdPresented = agencyCreationEnabled && params.has('agency_id');

    return agencyIdPresented && params.get('agency_id');
  }

  static get urlAdditionalQueries() {
    const url = new URL(SSORedirect.urlBase);
    url.searchParams.append('redirect_url', window.location.href);
    if (SSORedirect.agencyIdParam) {
      url.searchParams.append('agency_code', SSORedirect.agencyIdParam);
    }
    return url.href;
  }

  /**
   * /login - currently being used when doing retrieval from SF as fallback login
   * /internal-login - currently only being used in macro as dev dont have access to default provider (azure login)
   *
   */
  login({ internal = false }) {
    if (window.config.limited_access?.redirect_url) {
      window.location.replace(window.config.limited_access?.redirect_url);
      return;
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const internalProviderId =
      window.config.sso?.provider_id_internal || window.config.sso?.provider_id;
    const providerId = window.config.sso?.provider_id;
    const url = new URL(SSORedirect.urlProviderSelection);
    url.searchParams.append(
      'provider_id',
      internal
        ? internalProviderId
        : urlParams.get('provider_id') || providerId,
    );
    url.searchParams.append(
      'redirect_url',
      urlParams.get('redirect_url') || baseUrl,
    );
    if (isDevEnv()) {
      window.location.assign(url.href.replaceAll('https', 'http'));
    } else {
      window.location.assign(url.href);
    }
  }

  /**
   * Logout user
   */
  logout() {
    const url = new URL(`${window.config.oidcClientUrl}/logout`);
    url.searchParams.append('provider_id', window.config.sso?.provider_id);
    url.searchParams.append(
      'redirect_url',
      `${SSORedirect.urlProviderSelection}?provider_id=${window.config.sso?.provider_id}`,
    );

    if (isDevEnv()) {
      window.location.assign(url.href.replaceAll('https', 'http'));
    } else {
      window.location.assign(url.href);
    }
  }
}

export const ssoRedirect = new SSORedirect();
